export const RatingValueEnum = {
    POSTITIVE: 1,
    NEGATIVE: 2
}